export default __webpack_public_path__ + "static/media/E_Estrela.a8d27398.mp3";